/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SavingProductGroupDetailResponseDto { 
    id?: number;
    creditUnionProductId?: number;
    name?: string | null;
    description?: string | null;
    typeId?: number;
    interestRate?: number;
    interestRatePeriodTypeId?: number;
    savingInterestCalculationTypeId?: number;
    savingInterestCompoundingPeriodId?: number;
    savingInterestPostingPeriodId?: number;
    isRecurringSaving?: boolean;
    recurringSavingAmount?: number;
    recurringSavingPeriodTypeId?: number;
    minimumBalance?: number;
    priorNotificationDays?: number;
    numberOfContributionPerCycle?: number;
    memberCapacity?: number;
    savingPeriodType?: string | null;
    recurringSavingPeriodType?: string | null;
    savingProductType?: string | null;
    interestCompoundingPeriod?: string | null;
    interestPostingPeriod?: string | null;
    interestCalculationType?: string | null;
    isPublic?: boolean;
}

